export default __webpack_public_path__ + "static/media/post.1bbd68aa.png";